module.exports = __webpack_public_path__ + "static/media/building-city-element-svgrepo-com.890061b0.svg";